var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.025 11.3C18.4536 11.3 17.1823 12.5713 17.1823 14.1426C17.1823 15.714 18.4536 16.9853 20.025 16.9853C21.5963 16.9853 22.8676 15.714 22.8676 14.1426C22.8676 12.5713 21.5963 11.3 20.025 11.3ZM21.7082 20.9661H18.3417C15.8199 20.9661 13.5 23.3482 13.5 26.6358V28.9497H26.55V26.6358C26.55 23.3482 24.23 20.9661 21.7082 20.9661ZM20.025 10C17.7356 10 15.8823 11.8533 15.8823 14.1426C15.8823 16.432 17.7356 18.2853 20.025 18.2853C22.3143 18.2853 24.1676 16.432 24.1676 14.1426C24.1676 11.8533 22.3143 10 20.025 10ZM21.7082 19.6661H18.3417C14.9523 19.6661 12.2 22.7896 12.2 26.6358V29.4753C12.2 29.9141 12.4957 30.2497 12.8824 30.2497H27.1675C27.5542 30.2497 27.85 29.9141 27.85 29.4753V26.6358C27.85 22.7896 25.0976 19.6661 21.7082 19.6661Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.985709fd96df955acc5630c8fae999bd.svg";
export { ForwardRef as ReactComponent };